// eslint-disable-next-line no-restricted-imports
import { View } from 'react-native';
import { styled } from 'dripsy';

// Mock KeyboardShift on web
export default styled(View)({ flex: 1 });
